<div class="fixed top-4 right-4 z-[3000] space-y-2">
  @for (toast of toastService.toasts$ | async; track toast.id) {
    <div
      class="min-w-[300px] max-w-md px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in toast-card"
      [ngClass]="{
        'toast-success': toast.type === 'success',
        'toast-error': toast.type === 'error',
        'toast-info': toast.type === 'info',
        'toast-warning': toast.type === 'warning'
      }">
      <div class="flex-1">{{ toast.message }}</div>
      <button
        (click)="toastService.remove(toast.id)"
        class="toast-close-btn"
        aria-label="Close">
        �
      </button>
    </div>
  }
</div>

